module.exports = new __parcel__URL__("issue-view-statistics-onboarding-dark-mode.18820f06.gif").toString();